// extracted by mini-css-extract-plugin
module.exports = {"container":"TrafficReports_container__35Hya","title":"TrafficReports_title__1yWyt","stats":"TrafficReports_stats__3FqHh"};